import React from "react";
import AuthLayout from "./AuthLayout";
import MarketingFooter from "./MarketingFooter";
import { SessionField, SubmitButton } from "./AuthFields";
import ActionLink from "./ActionLink";

const VerificationCodePage = ({
  action,
  resendPath,
  showSendToEmail,
  sendToEmailPath,
  verificationCodeFormPath,
  showBackToPhone,
  phoneNumberFormPath,
  logoutPath
}) => (
  <AuthLayout
    action={action}
    formClassName="login-form"
    formInnerStyle={{ marginTop: "30px" }}
    headerText="Please enter your Verification Code:"
    footer={
      <>
        <ul>
          <li>
            <ActionLink
              action={resendPath}
              nextPath={verificationCodeFormPath}
              className="logout"
            >
              Resend Verification Code
            </ActionLink>
          </li>
          {showSendToEmail && (
            <li>
              <ActionLink
                action={sendToEmailPath}
                nextPath={verificationCodeFormPath}
                className="logout"
              >
                Send Verification Code To Email
              </ActionLink>
            </li>
          )}
          {showBackToPhone && (
            <li>
              <a href={phoneNumberFormPath} className="logout">
                Back To Phone Input Form
              </a>
            </li>
          )}
          <li>
            <a href={logoutPath} className="logout">
              Logout
            </a>
          </li>
        </ul>
        <MarketingFooter />
      </>
    }
  >
    <SessionField
      type="text"
      name="user[verification_code]"
      id="user_verification_code"
      placeholder="Verification Code"
      className="verification"
      autoFocus
    />
    <div className="mtm">
      <SubmitButton value="Confirm" />
    </div>
  </AuthLayout>
);

export default VerificationCodePage;
